'use strict';

/*@ngInject*/
module.exports = function ($rootScope, $uibModal, publicObjectsService, publicUsersService, clipboard, systemIcons, $timeout, printService) {
	return {
		scope: {
			objectId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var restoreObjectsFilter = 'restoreObjectsFilter';

			var vm = this;
			vm.commentError = !$rootScope.currentUser;
			vm.userNotLoggedIn = !$rootScope.currentUser;
			vm.copyToClipboardSupported = true;
			vm.addCommentMessage = !$rootScope.currentUser ? 'to_add_comment ' : '';
			vm.userHasBookmark = false;
			vm.showSuggestionAddedMessage = false;
			vm.showSuggestionErrorMessage = false;
			vm.addingSuggestionsAllowed = false;
			vm.commentAddError = false;
			vm.commentAddErrorMessage = '';
			vm.commentAddSuccess = false;
			vm.imageModalOpen = false;
			vm.emptyCommentError = false;
			vm.directionsAvailable = false;
			vm.dirUrl = '';

			vm.servicesIcons = [];
			vm.otherFeaturesIcons = [];

			vm.selectedImageId = null;

			vm.$onInit = function () {
				vm.copyToClipboardSupported = clipboard.supported;

				publicObjectsService.getObjectDataById(vm.objectId).then(function (response) {
					vm.objectData = response.data;
					vm.selectedImageId = _.get(vm.objectData, 'image_files[0].id');
					vm.directionsUrl();

					var systemServicesIcons = systemIcons.features.services;
					angular.forEach(vm.objectData.feature_icons, function (icon) {
						if (systemServicesIcons.includes(icon.icon_path)) {
							vm.servicesIcons.push(icon);
						} else {
							vm.otherFeaturesIcons.push(icon);
						}
					});

					publicUsersService.userHasBookmark(vm.objectData.object_id, publicObjectsService.TYPE_OBJECT).then(function (result) {
						vm.userHasBookmark = result.data;
					});

					vm.commentsAllowed = response.data.comments_allowed;
					vm.addingSuggestionsAllowed = response.data.suggestions_allowed;
					vm.objectData.objectType = publicObjectsService.TYPE_OBJECT;
				});
			};

			vm.openSuggestionModal = function () {
				vm.showSuggestionAddedMessage = false;
				vm.showSuggestionErrorMessage = false;
				var modalInstance = $uibModal.open({
					template: require('./suggestions/object-suggestion-modal.directive.html'),
					controller: require('./suggestions/object-suggestion-modal.directive'),
					controllerAs: 'vm',
					size: 'lg',
					backdrop: 'static',
					keyboard: false,
					windowClass: 'center-modal',
					resolve: {
						data: function data() {
							return { object: vm.objectData, objectType: 'OBJECT' };
						}
					}
				});

				modalInstance.result.then(function (result) {
					if (result === 'ok') {
						vm.showSuggestionAddedMessage = true;
					} else {
						vm.showSuggestionErrorMessage = true;
					}
				});
			};

			vm.updateBookmark = function (objectId) {
				publicUsersService.updateBookmark(publicObjectsService.TYPE_OBJECT, objectId).then(function (result) {
					vm.userHasBookmark = !vm.userHasBookmark;
				});
			};

			vm.logIn = function () {
				return $rootScope.logIn();
			};

			vm.openImage = function () {
				$('.slick-current').find('a')[0].click();
			};

			vm.openGalery = function () {
				$('#magnific-popup').find('a')[0].click();
			};

			vm.prepareCoordinate = function (coordinate) {
				//remove spaces and replace commas with dots
				return coordinate.replace(/\s+/g, '').replace(/,/g, '.');
			};

			vm.directionsUrl = function () {
				vm.dirUrl = '/#';
				if (vm.objectData.lat && vm.objectData.lon) {
					if (vm.objectData.lat !== '0' && vm.objectData.lon !== '0') {
						var lat = typeof vm.objectData.lat === 'string' ? vm.prepareCoordinate(vm.objectData.lat) : vm.objectData.lat;
						var lon = typeof vm.objectData.lon === 'string' ? vm.prepareCoordinate(vm.objectData.lon) : vm.objectData.lon;
						vm.dirUrl = 'https://www.google.com/maps/dir//' + lat + ',' + lon;
						vm.directionsAvailable = true;
					}
				}
				return vm.dirUrl;
			};

			vm.addComment = function () {
				vm.commentAddError = false;
				if (vm.objectData.newComment === '' || !vm.objectData.newComment) {
					vm.emptyCommentError = true;
					vm.commentAddError = true;
					vm.commentAddErrorMessage = 'comment_is_required';
				} else {
					publicObjectsService.addComment(vm.objectData).then(function (res) {
						if (res.data === 'ok') {
							vm.commentError = false;
							vm.emptyCommentError = false;
							vm.commentAddSuccess = true;
							vm.addCommentMessage = 'comment_notification';
							vm.objectData.newComment = '';
						}
					});
				}
			};

			vm.print = function () {
				$timeout(function () {
					printService.printContent(vm.objectData.name, vm.getHtml());
				}, 1000);
			};

			vm.getHtml = function () {
				return _.get(angular.element('#printSection')[0], 'outerHTML');
			};

			vm.setRestoreFilter = function () {
				localStorage.setItem(restoreObjectsFilter, JSON.stringify(true));
			};
		},

		template: require('./object-details.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-details.directive.js
 **/